<template>
  <q-card
    class="checkDialog text-center full-width q-pt-md q-pb-sm border-radius-8"
  >
    <q-card-section
      v-if="group && group !== 'waitingPay' && reason"
      class="q-pt-none content"
    >
      <div class="content-icon">
        <slot name="icon">
          <q-icon name="r_error_outline" size="47px" color="negative" />
        </slot>
      </div>
      <div class="text-weight-bolder font-size-16 q-pt-sm">
        <span>{{ map[group][reason].text }}</span>
      </div>
      <div v-if="map[group][reason].btnText" class="q-mt-lg">
        <q-btn
          v-close-popup
          no-caps
          unelevated
          color="negative"
          class="border-radius-8 text-weight-bolder"
          :label="map[group][reason].btnText"
          @click="map[group][reason].callBack"
        />
      </div>
    </q-card-section>
    <template v-else>
      <q-card-section v-if="state === '1'" class="line-height-120">
        <q-circular-progress
          :thickness="0.25"
          indeterminate
          size="40px"
          color="primary"
        />
        <div class="text-weight-bolder font-size-16 q-pt-sm">
          <span>{{ $t('componentsBaseDialog.paying') }}</span>
        </div>
        <div class="text-theme-gray font-size-12 q-pt-xs">
          <span>{{ $t('componentsBaseDialog.payingMsg') }}</span>
        </div>
      </q-card-section>

      <q-card-section v-if="state === '2'" class="q-pt-none">
        <q-icon name="r_error_outline" size="47px" color="negative" />
        <div class="text-weight-bolder font-size-16 q-pt-sm">
          <span>{{ $t('componentsBaseDialog.goCartMsg') }}</span>
        </div>
        <div class="q-mt-lg">
          <q-btn
            no-caps
            unelevated
            :to="`/${storeUrl}/cart`"
            color="negative"
            class="border-radius-8 text-weight-bolder"
            label="Kembali ke cart"
          />
        </div>
      </q-card-section>

      <q-card-section v-if="state === '3'" class="q-pt-none">
        <q-icon name="r_error_outline" size="47px" color="negative" />
        <div class="text-weight-bolder font-size-16 q-pt-sm">
          <span>{{ $t('componentsBaseDialog.payErrorMsg1') }}</span>
        </div>
        <div class="q-mt-lg">
          <q-btn
            v-close-popup
            no-caps
            unelevated
            :to="`/${storeUrl}/checkout`"
            color="negative"
            class="border-radius-8 text-weight-bolder font-size-16"
            label="OK"
          />
        </div>
      </q-card-section>

      <q-card-section v-if="state === '4'" class="q-pt-none">
        <q-icon name="r_error_outline" size="47px" color="negative" />
        <div class="text-weight-bolder font-size-16 q-pt-sm">
          <span>
            {{ $t('componentsBaseDialog.payErrorMsg2') }}
          </span>
        </div>
        <div class="q-mt-lg">
          <q-btn
            no-caps
            unelevated
            color="negative"
            class="border-radius-8 text-weight-bolder"
            label="Coba lagi"
            :loading="isLoading"
            @click="onReOrder"
          />

          <q-btn
            no-caps
            unelevated
            style="margin-top: 10px"
            class="border-radius-8 text-weight-bolder btn-default"
            label="Membatalkan"
            :loading="isLoading2"
            @click="onReOrderCart"
          />
        </div>
      </q-card-section>

      <q-card-section v-if="state === '5'" class="q-pt-none">
        <q-icon name="schedule" size="46px" color="grey-6" />
        <div class="text-weight-bolder font-size-16 q-pt-sm">
          <span>{{ $t('componentsBaseDialog.payTimeoutErrorMsg') }}</span>
        </div>
        <!-- <div class="q-mt-lg">
          <q-btn
            no-caps
            unelevated
            :to="`/${storeUrl}/products-list`"
            color="negative"
            class="border-radius-8 text-weight-bolder font-size-16"
            label="Lanjutkan memesan"
          />
        </div> -->
        <div class="q-mt-lg">
          <q-btn
            no-caps
            unelevated
            color="negative"
            class="border-radius-8 text-weight-bolder"
            label="Coba lagi"
            :loading="isLoading"
            @click="onReOrder"
          />
          <q-btn
            no-caps
            unelevated
            style="margin-top: 10px"
            class="border-radius-8 text-weight-bolder btn-default"
            label="Membatalkan"
            :loading="isLoading2"
            @click="onReOrderCart"
          />
        </div>
      </q-card-section>

      <q-card-section v-if="state === '6'" class="q-pt-none">
        <q-icon name="r_error_outline" size="47px" color="negative" />
        <div class="text-weight-bolder font-size-16 q-pt-sm">
          <span>
            {{ $t('componentsBaseDialog.payErrorMsg3') }}
          </span>
        </div>
        <div class="q-mt-lg">
          <q-btn
            v-close-popup
            no-caps
            unelevated
            color="negative"
            class="border-radius-8 text-weight-bolder"
            label="OK"
            @click="handlerClickBtn('6')"
          />
        </div>
      </q-card-section>

      <q-card-section v-if="state === '7'" class="q-pt-none">
        <q-icon name="r_error_outline" size="47px" color="negative" />
        <div class="text-weight-bolder font-size-16 q-pt-sm">
          <span>
            {{ $t('componentsBaseDialog.payErrorMsg4') }}
          </span>
        </div>
        <div class="q-mt-lg">
          <q-btn
            v-close-popup
            no-caps
            unelevated
            color="negative"
            class="border-radius-8 text-weight-bolder"
            label="OK"
            @click="handlerClickBtn('7')"
          />
        </div>
      </q-card-section>

      <q-card-section v-if="state === '8'" class="q-pt-none">
        <q-icon name="r_error_outline" size="47px" color="negative" />
        <div class="text-weight-bolder font-size-16 q-pt-sm">
          <span>
            {{ $t('componentsBaseDialog.payErrorMsg5') }}
          </span>
        </div>
        <div class="q-mt-lg">
          <q-btn
            v-close-popup
            no-caps
            unelevated
            color="negative"
            class="border-radius-8 text-weight-bolder"
            label="OK"
            @click="handlerClickBtn('8')"
          />
        </div>
      </q-card-section>

      <q-card-section v-if="state === '9'" class="q-pt-none">
        <q-icon name="r_error_outline" size="47px" color="negative" />
        <div class="text-weight-bolder font-size-16 q-pt-sm">
          <span>{{ $t('componentsBaseDialog.payErrorMsg6') }}</span>
        </div>
        <div class="q-mt-lg">
          <q-btn
            v-close-popup
            no-caps
            unelevated
            color="negative"
            class="border-radius-8 text-weight-bolder"
            label="OK"
            @click="handlerClickBtn('9')"
          />
        </div>
      </q-card-section>
    </template>

    <!--  通用组件 -->
  </q-card>
</template>

<script>
import { reOrder } from 'src/api/order';
import { getTable } from '../utils/common';

export default {
  props: {
    group: {
      type: String,
      default: 'productDetails',
    },
    reason: {
      type: String,
      default: 'out_of_stock',
    },
    state: {
      type: String,
      default: '1',
    },
    onRefresh: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
      isLoading2: false,
      map: {
        // 购物车
        cart: {
          out_of_product_stock: {
            text: this.$t('componentsBaseDialog.cartNotStock1'),
            btnText: 'OK',
            callBack: this.refresh,
          },
          out_of_modifier_option_stock: {
            text: this.$t('componentsBaseDialog.cartNotStock2'),
            btnText: 'OK',
            callBack: this.refresh,
          },
        },
        productDetails: {
          out_of_stock: {
            text: this.$t('componentsBaseDialog.productDetailsErrorMsg1'),
            btnText: 'OK',
            callBack: this.goList,
          },
          not_in_live: {
            text: this.$t('componentsBaseDialog.productDetailsErrorMsg2'),
            btnText: 'OK',
            callBack: this.goList,
          },
          option_illegal: {
            text: this.$t('componentsBaseDialog.productDetailsErrorMsg3'),
            btnText: 'OK',
            callBack: this.refresh,
          },
          product_changed: {
            text: this.$t('componentsBaseDialog.productDetailsErrorMsg4'),
            btnText: 'OK',
            callBack: this.refresh,
          },
          out_of_product_stock: {
            text: this.$t('componentsBaseDialog.productDetailsErrorMsg5'),
            btnText: 'Kembali',
            callBack: this.refresh,
          },
          out_of_modifier_option_stock: {
            text: this.$t('componentsBaseDialog.productDetailsErrorMsg6'),
            btnText: 'Kembali',
            callBack: this.refresh,
          },
          modifier_illegal: {
            text: this.$t('componentsBaseDialog.payPageErrorMsg3'),
            btnText: 'OK',
            callBack: this.refresh,
          },
        },
        shopCart: {
          out_of_stock: {
            text: this.$t('componentsBaseDialog.shopCartErrorMsg1'),
            btnText: this.$t('componentsBaseDialog.shopCartErrorMsg1BtnText'),
            callBack: this.refresh,
          },
          not_in_live: {
            text: this.$t('componentsBaseDialog.shopCartErrorMsg2'),
            btnText: this.$t('componentsBaseDialog.shopCartErrorMsg2BtnText'),
            callBack: this.refresh,
          },
          option_illegal: {
            text: this.$t('componentsBaseDialog.shopCartErrorMsg3'),
            btnText: 'OK',
            callBack: this.goPay,
          },
          product_changed: {
            text: this.$t('componentsBaseDialog.shopCartErrorMsg4'),
            btnText: 'OK',
            //  去支付
            callBack: this.goPay,
          },
          out_of_product_stock: {
            text: this.$t('componentsBaseDialog.shopCartErrorMsg5'),
            btnText: 'OK',
            callBack: this.refresh,
          },
          out_of_modifier_option_stock: {
            text: this.$t('componentsBaseDialog.shopCartErrorMsg6'),
            btnText: 'OK',
            callBack: this.refresh,
          },
          modifier_changed: {
            text: this.$t('componentsBaseDialog.payPageErrorMsg3'),
            btnText: 'OK',
            //  继续支付
            callBack: this.goPay,
          },
        },
        payPage: {
          out_of_stock: {
            text: this.$t('componentsBaseDialog.payPageErrorMsg1'),
            btnText: this.$t('componentsBaseDialog.payPageErrorMsg1BtnText'),
            callBack: this.goCart,
          },
          not_in_live: {
            text: this.$t('componentsBaseDialog.payPageErrorMsg2'),
            btnText: this.$t('componentsBaseDialog.payPageErrorMsg2BtnText'),
            callBack: this.goCart,
          },
          option_illegal: {
            text: this.$t('componentsBaseDialog.payPageErrorMsg3'),
            btnText: 'OK',
            callBack: this.refresh,
          },
          modifier_illegal: {
            text: this.$t('componentsBaseDialog.payPageErrorMsg3'),
            btnText: 'OK',
            callBack: this.refresh,
          },
          modifier_changed: {
            text: this.$t('componentsBaseDialog.payPageErrorMsg3'),
            btnText: 'OK',
            //  继续支付
            callBack: this.refresh,
          },
          product_changed: {
            text: this.$t('componentsBaseDialog.payPageErrorMsg4'),
            btnText: 'OK',
            //  继续支付
            callBack: this.refresh,
          },
          out_of_product_stock: {
            text: this.$t('componentsBaseDialog.payPageErrorMsg5'),
            btnText: this.$t('componentsBaseDialog.payPageErrorMsg5BtnText'),
            callBack: this.goCart,
          },
          out_of_modifier_option_stock: {
            text: this.$t('componentsBaseDialog.payPageErrorMsg6'),
            btnText: this.$t('componentsBaseDialog.payPageErrorMsg6BtnText'),
            callBack: this.goCart,
          },
          orderType_is_illegal_DELIVERY: {
            text: this.$t('componentsBaseDialog.notSupprotDELIVERY'),
            callBack: this.goHome,
            btnText: this.$t('componentsBaseDialog.changeOrderType'),
          },
          orderType_is_illegal_DINE_IN: {
            text: this.$t('componentsBaseDialog.notSupprotDINE_IN'),
            callBack: this.goHome,
            btnText: this.$t('componentsBaseDialog.changeOrderType'),
          },
          orderType_is_illegal_PICK_UP: {
            text: this.$t('componentsBaseDialog.notSupprotPICK_UP'),
            callBack: this.goHome,
            btnText: this.$t('componentsBaseDialog.changeOrderType'),
          },
          orderType_is_illegal_FULL_DINE_IN: {
            text: this.$t('componentsBaseDialog.notSupprotDINE_IN'),
            callBack: this.goHome,
            btnText: this.$t('componentsBaseDialog.changeOrderType'),
          },
          tableNumber_is_illegal: {
            text: '',
            callBack: this.refresh,
          },
        },
      },
    };
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
  },
  watch: {
    reason(newV, oldV) {
      this.initPayPage();
      if (newV !== 'out_of_stock') {
        this.IS_SHOW_DIALOG = true;
      }
    },
  },
  created() {
    this.initPayPage();
  },
  methods: {
    // 重新支付
    onReOrder() {
      this.isLoading = true;
      reOrder({
        orderId: this.orderId,
      }).then(() => {
        // 服务端数据有延迟，所以延迟一秒处理
        setTimeout(() => {
          this.isLoading = false;
          window.location.href = `/${this.storeUrl}/checkout`;
        }, 1000);
      });
    },
    // 加入购物车
    onReOrderCart() {
      this.isLoading2 = true;
      reOrder({
        orderId: this.orderId,
      }).then(() => {
        this.isLoading2 = false;
        window.location.href = `/${this.storeUrl}/products-list`;
        // this.$router.push({ path: `/${this.storeUrl}/products-list` });
      });
    },
    goCart() {
      window.location.href = `/${this.storeUrl}/cart`;
      // this.$router.push({ path: `/${this.storeUrl}/cart` });
    },
    goList() {
      window.location.href = `/${this.storeUrl}/products-list`;
      // this.$router.push({ path: `/${this.storeUrl}/products-list` });
    },
    refresh() {
      window.location.reload();
      // this.$router.go(0);
    },
    goPay() {
      if (this.isFullDineIn) {
        window.location.href = `/${this.storeUrl}/cart_confirm`;
      } else {
        window.location.href = `/${this.storeUrl}/checkout`;
      }
      // this.$router.push({ path: `/${this.storeUrl}/checkout` });
    },
    goHome() {
      window.location.href = `/${this.storeUrl}`;
    },
    handlerClickBtn(val) {
      /*
       * val对应状态:
       * 6 => 库存
       * 7 => 下架
       * 8 => modifiers
       * 9 => 库存 简
       */
      const path = this.$router.currentRoute.fullPath;
      if (path === `/${this.storeUrl}/cart`) {
        this.$router.push({ path: `/${this.storeUrl}/cart` });
      } else if (path === `/${this.storeUrl}/checkout`) {
        if (val === '6' || val === '7' || val === '9') {
          this.$router.push({ path: `/${this.storeUrl}/cart` });
        } else if (val === '8') {
          this.$router.go(0);
        }
      } else if (val === '6' || val === '7' || val === '9') {
        this.$router.push({ path: `/${this.storeUrl}/products-list` });
      } else if (val === '8') {
        this.$router.go(0);
      }
    },
    reloadPage() {
      this.$router.go(0);
    },
    close() {
      this.$emit('update:alert-await', false);
      this.$emit('update:reason', '');
    },
    initPayPage() {
      if (this.reason === 'tableNumber_is_illegal') {
        const tableType = this.$t(`list.table${this.storeInfo.businessType}`);
        const table = getTable();
        this.map.payPage[this.reason].text = this.$t(
          'componentsBaseDialog.payTableNotFound',
          {
            v1: tableType,
            v2: table,
          },
        );
        this.map.payPage[this.reason].callBack = this.close;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.checkDialog {
  .q-btn {
    width: 220px;
    height: 40px;
  }
  .btn-default {
    border: 1px solid #d1d5db;
  }
  .content {
    border-radius: 8px !important;
    padding-top: 16px !important;
    &-icon {
      margin-bottom: 16px;
    }
  }
}
</style>
